
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(442|70|805|830)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
